import { DateTime } from 'luxon';

export interface TimeRange {
    startTime: DateTime;
    endTime: DateTime;
}

export type EventTime = {
    iteration: number;
    startTime: string;
    endTime: string;
};

export const generateBlocksInTimeRange = (startTime: DateTime, endTime: DateTime, duration: number): EventTime[] => {
    const blocks: EventTime[] = [];
    let currentStartTime = startTime;
    let iteration = 0;
    while (currentStartTime < endTime) {
        const currentEndTime = currentStartTime.plus({ minutes: duration });

        blocks.push({
            iteration,
            startTime: currentStartTime.toISO(),
            endTime: currentEndTime.toISO(),
        });
        iteration++;
        currentStartTime = currentEndTime;
    }

    return blocks;
};
